import React, {Dispatch, SetStateAction, useState, useEffect} from 'react'
import {Modal} from 'react-bootstrap'
import { useMutation, useQueryClient } from 'react-query'
import { KTSVG, QUERIES } from '../../../../../../_metronic/helpers'
import { useQueryResponse } from '../core/QueryResponseProvider'
import { Embedding } from '../core/_models'
import { useCompanies } from '../../../../auth/core/Companies'
import { deleteEmbedding, deleteFile } from '../core/_requests'

type Props = {
  show: boolean
  action : boolean
  embedding : Embedding
  handleClose: () => void
  deleteQuery: () => void
}

const DeleteWarningModal: React.FC<Props> = ({show, handleClose, deleteQuery , action, embedding}) => {
  const {query} = useQueryResponse()
  const queryClient = useQueryClient()
  const {defaultCompany} = useCompanies()

  const updateStatus = useMutation(() => deleteFile(embedding._id,defaultCompany?.company_id ?? ''), {
    // 💡 response of the mutation is passed to onSuccess
    onSuccess: () => {
      // ✅ update detail view directly
      queryClient.invalidateQueries([`${QUERIES.USERS_LIST}-${query}`])
      handleClose()
    },
  })

 

  


  return (
    <Modal
      className='modal fade'
      id='kt_modal_select_location'
      data-backdrop='static'
      tabIndex={-1}
      role='dialog'
      show={show}
      dialogClassName='modal-xs mt-10'
      aria-hidden='true'
      onHide={handleClose}
    >
      <div className='modal-content'>
        <div className='modal-header'>
          <h5 className='modal-title'>Delete File</h5>

          <div className='btn btn-icon btn-sm btn-active-light-primary ms-2' onClick={handleClose}>
            <KTSVG path='/media/icons/duotune/arrows/arr061.svg' className='svg-icon-2x' />
          </div>
        </div>
        <div className='modal-body'>
          <p>Are you sure want to delete this file?</p>
        </div>
        <div className='modal-footer'>
          <button
            type='button'
            className='btn btn-light-primary'
            onClick={() => handleClose()}
          >
            No
          </button>
          <button
            id='submit'
            type='button'
            className='btn btn-primary'
            onClick={() => updateStatus.mutateAsync()}
          >
            Yes
          </button>
        </div>
      </div>
    </Modal>
  )
}

export {DeleteWarningModal}
